export default __webpack_public_path__ + "static/media/Via_Vorderseite_2.1ca529c0.jpg";